import { getFileFullUrl } from '~/utils/file';

export const getLeaseImage = (lease: any): { image?: string; thumbnail?: string } => {
  const image = lease.unit.imageSignedUrl || lease.property.imageSignedUrl;
  const thumbnail = lease.unit.imageSignedThumbUrl || lease.property.imageSignedThumbUrl;
  const url = image ? getFileFullUrl(image) : undefined;
  const thumbUrl = thumbnail ? getFileFullUrl(thumbnail) : url;
  return { image: url, thumbnail: thumbUrl };
};
